import * as types from '../types/catalogTypes';
import * as catalogService from '../../services/catalogService';
import { mergedCatalogToBrowseCards } from '../../utils/catalogBrowse';

export const fetchCatalog = (opts = 30) => async (dispatch) => {
  const raw =
    typeof opts === 'number'
      ? { limit: opts }
      : {
          limit: opts.limit ?? 30,
          group: opts.group,
          genre: opts.genre,
          region: opts.region,
          language: opts.language,
          counts: opts.counts,
          clearPrevious: opts.clearPrevious,
        };
  const params = { ...raw };
  delete params.clearPrevious;
  const clear =
    typeof opts === 'object' && opts != null
      ? (opts.clearPrevious ?? Boolean(opts.group || opts.genre))
      : false;

  dispatch({ type: types.FETCH_CATALOG_REQUEST, payload: { clear } });
  try {
    const data = await catalogService.getCatalog(params);
    const items = mergedCatalogToBrowseCards(data.items || []);
    dispatch({
      type: types.FETCH_CATALOG_SUCCESS,
      payload: { source: data.source || 'catalog', items, counts: data.counts },
    });
  } catch {
    dispatch({ type: types.FETCH_CATALOG_FAILURE, payload: 'Failed to load catalog' });
  }
};

export const fetchCatalogByGenre = ({ genreSlug, region, language, limit = 200 }) => async (dispatch) => {
  dispatch({ type: types.FETCH_CATALOG_REQUEST, payload: { clear: true } });
  try {
    const data = await catalogService.getCatalog({ limit, genre: genreSlug, region, language });
    const items = mergedCatalogToBrowseCards(data.items || []);
    dispatch({
      type: types.FETCH_CATALOG_SUCCESS,
      payload: { source: data.source || 'catalog', items },
    });
  } catch {
    dispatch({ type: types.FETCH_CATALOG_FAILURE, payload: 'Failed to load catalog by genre' });
  }
};
